import weixinJSBridge from './weixinJSBridge.js'
import aliPay from './aliPay.js'

let isAndroid =
  navigator.userAgent.indexOf('Android') > -1 ||
  navigator.userAgent.indexOf('Adr') > -1;
let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
let isApp = navigator.userAgent.indexOf('communityapp') > -1

// 这是必须要写的，用来创建一些设置
function setupWebViewJavascriptBridge(callback) {
  console.log(isAndroid, 'isAndroid')
  // Android使用
  if (isAndroid) {
    if (window.WebViewJavascriptBridge) {
      // eslint-disable-next-line no-undef
      callback(WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        'WebViewJavascriptBridgeReady',
        function () {
          callback(WebViewJavascriptBridge); // eslint-disable-line
        },
        false,
      );
    }
  }

  // iOS使用
  if (isiOS) {
    if (window.WebViewJavascriptBridge) {
      // eslint-disable-line
      return callback(window.WebViewJavascriptBridge); // eslint-disable-line
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}
// 注册回调函数，第一次连接时调用 初始化函数(android需要初始化,ios不用)
setupWebViewJavascriptBridge(function (bridge) {
  if (isAndroid) {
    // 初始化
    bridge.init(function (message, responseCallback) {
      var data = {
        'Javascript Responds': 'Wee!'
      }
      responseCallback(data)
    })
  }

  // 注册搜索事件
  bridge.registerHandler('setSearchKey', function (data, responseCallback) {
    responseCallback({data: 'success'})
  })

  // 注册搜索事件
  bridge.registerHandler('setCommunityData', function (data, responseCallback) {

    if (!data) {
      responseCallback({data: 'error'})
      return
    }

    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    responseCallback({data: 'success'})
  })

   // 注册搜索事件
  bridge.registerHandler('getChallengeInfo', function (data, responseCallback) {
    console.log('挑战信息', data)

    if (!data) {
      responseCallback({data: 'error'})
      return
    }

    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    responseCallback({data: 'success'})
  })
})

export default {
  /**
   * js 调用 App 提供的方法
   *
   * @param name 方法名
   * @param data 传给 App 的数据
   * @param callback 回调
   */
  callHandler(name, data, callback) {
    return new Promise(resolve => {
      setupWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler(name, JSON.stringify(data), response => {
          console.log(response,'回掉函数')
          if (!response) rejected()
          if (typeof response === 'string') {
            response = JSON.parse(response);
          }
          if (callback) {
            callback && callback()
          }
           // 调用成功，使用保留的resolve改变返回的promise状态
          resolve(response);
        });
      });
    });
  },

  /**
   * App 调用 js 提供的方法
   *
   * @param name 方法名
   * @param callback 回调
   */
  registerHandler(name, success) {
    setupWebViewJavascriptBridge(function (bridge) {
      // eslint-disable-next-line no-unused-vars
      bridge.registerHandler(name, data => {
        console.info(`[JsBridge][Register][${name}] Success response:`, data);
        if (data && typeof data === 'string') {
          data = JSON.parse(data);
        }
        success(data);
      });
    });
  },

  /**
   * 获取用户信息
   *
   * @return userInfo 的所有字段和 token，放在一个对象里
   */
  async getUserInfo() {
    const data = await this.callHandler('getUserInfo');
    return data;
  },
  /**
   * 选择照片
   *
   * @param count 最大数量
   * @param type 类型，image：图片，video：视频，audio：音频, camera: 拍摄, photoAlbum: 相册
   * @return 上传后图片信息数组
   */
  async chooseImage({ count, type, albumKey }) {
    return await this.callHandler('chooseImage', { count, type, albumKey });
  },
  /* 储存分享数据
    {
    key: ''
    title: 名称
    description: 描述
    shareUrl: 分享路径
    operateType: transSend==>h5转发，share===》设置数据，原生操作，personalChat===>私聊
    url: h5跳转路由
    }
  */
  async setShareData (shareData = {},callback) {
    return await this.callHandler('setShareData', shareData,callback);
  },
   /**
   * 放大照片
   *
   * @param index 当前下标 0
   * @param list 图片数组列表["url","url",....]
   * @param type 模式,默认图片，可传:‘图文’
   */
  async showImagePicker(index = 0, imagesUrl = [], imageTextUrl=[]) {
    let data = {index, imagesUrl}
    if (imageTextUrl.length) {
      data.imageTextUrl = imageTextUrl
    }
    this.callHandler('showImagePicker', data)
  },
  /**
   * 视频播放
   *
   * @param src 当前资源
   */
  startPlayVideo(videoUrl) {
    this.callHandler('startPlayVideo', {videoUrl})
  },
  /**
   * 开始录音
   * @return
   */
  async startAudio() {
    return await this.callHandler('startAudio', '');
  },
  /**
   * 开始录音
   * @return
   */
  async stopAudio() {
    return await this.callHandler('stopAudio', '');
  },
  /**
   * 音频播放
   *
   * @param src 当前资源
   */
  async startPlayAudio(audioUrl, type) {
    let res = await this.callHandler('startPlayAudio', { audioUrl, type });
    console.log(res, audioUrl, type,'startPlayAudio')
    return res
  },
  /**
   * 唤起原生支付
   *
   * @param payContent 支付的签名内容
   * param.payType: 2 微信app  1 支付宝app 3 微信js  4 支付宝h5
   */
  startPay(payContent, callback) {
    return new Promise(async (resolve, rejected) => {
      if (payContent.payType == 0) {
        weixinJSBridge.payStart({
          appId: payContent.appId,     // 公众号名称，由商户传入     
          timeStamp: payContent.timeStamp + '',      // 时间戳，自1970年以来的秒数     
          nonceStr: payContent.nonceStr,   //随机串     
          package: payContent.package, 
          signType: 'MD5',    // 微信签名方式     
          paySign: payContent.paySign    // 微信签名 
        }, () => {
          callback && callback()
          resolve()
        })

        return
      } else if (payContent.payType == 5) {
        aliPay.payStart(payContent.content)
        callback && callback()
        resolve()
        return
      }
      resolve(await this.callHandler('startPay', payContent, callback))
    })
  },
  async setHeader (headerConfig = {}) {
    headerConfig.style = headerConfig.style ? headerConfig.style : 'dark'
    headerConfig.tools = headerConfig.tools ? headerConfig.tools : {}
    headerConfig.tools.search = headerConfig.tools.search === 1 ? 1 : 0
    headerConfig.tools.share = headerConfig.tools.share === 1 ? 1 : 0
    headerConfig.tools.title = headerConfig.tools.title === 0 ? 0 : 1
    headerConfig.tools.back = headerConfig.tools.back === 0 ? 0 : 1
    headerConfig.tools.rightText = headerConfig.tools.rightText ? headerConfig.tools.rightText : {}
    return await this.callHandler('setHeader', headerConfig)
  },
  async getLayoutInfo () {
    return await this.callHandler('getLayoutInfo', '');
  },
  async openApp () {
    return await this.callHandler('openApp', '');
  },
  /**
   * 跳转到原生页面
   * 后期让原生将key,type放进 remarkData
   * @param path 页面路径
   */
  async navigateTo(path, key = '', type = '', remarkData = {}, callback) {
   return await this.callHandler('navigateTo', {path, key, type, remarkData},callback);
  },
  /**
   * 回退到上一个原生页面
   */
  navigateBack(actionStr) {
    this.callHandler('navigateBack', actionStr);
  },
  /**
   * 分享
   */

  async gotoShare(param,callback) {
    return await this.callHandler('gotoShare', param,callback);
  },
   /**
   * 联系客服拨打电话
   *
   * @param number 电话号码
   */
  callTel(number) {
    this.callHandler('callTel', number)
  },
  async geolocation () {
    const data = await this.callHandler('geolocation');
    return data
  },
  // 获取原生账单缴费信息（订单数据和地址数据）
  async getSelectFeesInfo () {
    return await this.callHandler('getSelectFeesInfo', '');
  },
  // 二维码
  async scanCode (callback) {
    return await this.callHandler('scanCode', '');
  },
  // 告知原生需要重新加载跳转h5之前的api，比如我的-账单，h5如有支付操作，回来需要重新加载
  bridgeReloadApi () {
    this.callHandler('bridgeReloadApi');
  },
}

